export default () => ({
  calibrationHomepageMessage: null
})



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/state.js